import { router } from "@/router";

export const notFoundInterceptor = (error) => {
  router.push({ name: "Error404" }).then();

  return Promise.reject(error);
};
